/**
 * The usb vendor and product ids the boards report, which narrow both choosers
 * the linking flow opens.
 *
 * The serial number is read over WebUSB before the board is linked, so at that
 * point there is no port to take the ids from and the chooser would offer every
 * usb device on the machine. A serial read off something picked out of that list
 * would be pinned on the board with nothing to say it belongs to it, so the list
 * is narrowed to the ids the boards are known to report. The port chooser that
 * follows is then narrowed to the ids of the device that was picked, which is
 * what keeps the two choosers of the flow pointing at the same board.
 *
 * An empty list means no filter, and every device is offered. That is where this
 * starts: the ids go in as they are read off real boards. Adding one only ever
 * narrows the chooser, so a board whose ids are missing from a non-empty list
 * stops appearing in it - which is why an id belongs here once it has been seen,
 * and not before.
 *
 * Written the way they read in the usb descriptor and in the port names the
 * selector shows: '0x' followed by four hex digits. Upper or lower case both
 * parse, so '0x1A86' and '0x1a86' are the same id.
 */
export const BOARD_USB_IDS = [
  // { vendorId: '0x1a86', productId: '0x7523' },
];
